module.exports = __webpack_public_path__ + "static/media/file-invoice-dollar-solid.7aaa0a4e.svg";